import { render, staticRenderFns } from "./LectureTrackSubjectEntityDetails.vue?vue&type=template&id=6d946950&scoped=true"
import script from "./LectureTrackSubjectEntityDetails.vue?vue&type=script&lang=js"
export * from "./LectureTrackSubjectEntityDetails.vue?vue&type=script&lang=js"
import style0 from "./LectureTrackSubjectEntityDetails.vue?vue&type=style&index=0&id=6d946950&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d946950",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d946950')) {
      api.createRecord('6d946950', component.options)
    } else {
      api.reload('6d946950', component.options)
    }
    module.hot.accept("./LectureTrackSubjectEntityDetails.vue?vue&type=template&id=6d946950&scoped=true", function () {
      api.rerender('6d946950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LectureTrackSubjectEntityDetails.vue"
export default component.exports